import React from 'react';

import * as S from './styled';

const Small = props => <S.Small to={props.to}>{props.children}</S.Small>


export default Small;